var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-height":"65vh"}},[_c('div',{staticClass:"py-12"},[_vm._t("content")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }